var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MRadioGroup',{attrs:{"as-button":"","options":_vm.currentOptions,"disabled":_vm.disabled},model:{value:(_vm.currentType),callback:function ($$v) {_vm.currentType=$$v},expression:"currentType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }